import { Tooltip, TooltipTrigger, TooltipContent } from './ui/tooltip';

const Tip = ({ children, text, side = 'bottom', className = '' }) => {
  if (!text) return children;
  return (
    <Tooltip delayDuration={300}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side} className={`text-xs max-w-[200px] ${className}`}>
        {text}
      </TooltipContent>
    </Tooltip>
  );
};

export default Tip;
